import { IGif } from '@giphy/js-types'
import loadable from '@loadable/component'
import React, { FC } from 'react'
import { connect } from 'react-redux'
import { toggleEditMode, updateEditMode } from 'shared/redux/edit-mode'
import { getEditModeIsEditing } from 'shared/redux/reducers'
import ModalContext from './modal'

const GifEditPanel = loadable(() =>
    import(/* webpackChunkName: "gifEditPanel" */ 'shared/components/edit-panel/gif-modal')
)

type Props = {
    isEditing: Boolean
    updateEditMode: (gif?: Object, channel?: Object) => void
    toggleEditMode: (isOn?: Boolean) => void
}

const ModalContextManager: FC<Props> = ({ isEditing, updateEditMode, toggleEditMode, children }) => {
    const openGifEditPanel = (gif: IGif) => {
        updateEditMode(gif)
        toggleEditMode(true)
    }
    return (
        <ModalContext.Provider
            value={{
                openGifEditPanel,
            }}
        >
            {children}
            {isEditing && <GifEditPanel />}
        </ModalContext.Provider>
    )
}

export default connect(
    state => ({
        isEditing: getEditModeIsEditing(state),
    }),
    {
        updateEditMode,
        toggleEditMode,
    }
)(ModalContextManager)
